// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__57oS1","messages":"Chat_messages__v0VEX","dateDivider":"Chat_dateDivider__3-Ysp"};